import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import Slider, { SliderThumb, SliderProps } from '@mui/material/Slider';


const StyledSlider = styled(Slider)`
  ${({ theme }) => css`
    & .MuiSlider-thumb {
      height: 16px;
      width: 16px;
      background-color: ${theme.thumbBackground};
      border: 1px solid ${theme.playerDataBorder};
      border-radius: 3px;

      & .thumb-bars {
        height: 12px;
        width: 1px;
        background-color: ${theme.playerColor};
        margin-left: 1px;
        margin-right: 1px;
      }
    }

    & .MuiSlider-track {
      height: 6px;
      background-color: #00d1a8;
      border: 1px solid #00d1a8;
    }
    & .MuiSlider-rail {
        background-color: ${theme.playerDataBorder}
    }
    & .MuiSlider-thumb:hover {
        border-radius: 3px;
        border: 1px solid ${theme.playerCardBorderColor};
        background: ${theme.thumbHoverBackground};
        box-shadow: none;
    }
  `}
`;



const ThumbComponent: React.FC<React.HTMLAttributes<unknown>> = (props) => {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <span className="thumb-bars" />
      <span className="thumb-bars" />
    </SliderThumb>
  );
};

interface CustomSliderComponentProps {
  value: number[];
  min: number;
  max: number;
  step: number;
  onChange: SliderProps['onChange'];
  onDataUpdate?: SliderProps['onChangeCommitted'];
}

const CustomSliderComponent: React.FC<CustomSliderComponentProps> = ({ value, min, max, step, onChange, onDataUpdate }) => {
  const [sliderValue, setSliderValue] = useState<number[]>(value); // Manage local state
  // Update local state when the value prop changes
  useEffect(() => {
    setSliderValue(value);
  }, [value]);


  const confirmSliderChange: SliderProps['onChangeCommitted'] = (event, newValue) => {
    onDataUpdate && onDataUpdate(event, newValue);
  };

  const handleSliderChange: SliderProps['onChange'] = (event, newValue, activeThumb) => {
    onChange && onChange(event, newValue, activeThumb); // Call parent's onChange handler
    setSliderValue(newValue as number[]); // Update local state
  }

  return (
    <StyledSlider
      components={{ Thumb: ThumbComponent }}
      value={sliderValue}
      min={min}
      max={max}
      step={step}
      onChange={handleSliderChange}
      onChangeCommitted={confirmSliderChange}
    />
  );
};

export default CustomSliderComponent;
